import styles from "@/components/modal/license-limited-modals/styles/limit-expired-credit-modal.module.scss";
import { useCreditBalance } from "@/hooks/providers/credit-balance-provider";
import Loader from "@/components/common/loader";
import FilledButton from "@/components/common/filled-button";
import IncreaseLimitsButton from "@/components/common/increase-limits-button";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import { useLoggingContext } from "@/providers/logging-provider/logging-provider";

type LimitExpiredCreditModalBaseProps = {
  action: string;
  priceInCredits: number;
  onUseCreditsClick: () => Promise<void>;
};

export type LimitExpiredCreditModalProps = {
  handleUseCreditsClick: (
    transaction: () => Promise<void>,
    priceInCredits: number,
  ) => Promise<void>;
};

const LimitExpiredCreditModal = ({
  action,
  priceInCredits,
  onUseCreditsClick,
}: LimitExpiredCreditModalBaseProps) => {
  const { creditBalance, isFetchingBalance, handleCreditTransaction } =
    useCreditBalance();
  const { hideModal } = useGlobalModalContext();
  const logger = useLoggingContext();

  const warning = `Your base limit has expired, use credits to make a ${action}`;
  const price = `1 ${action} = ${priceInCredits} ${priceInCredits === 1 ? "credit" : "credits"}`;

  return (
    <div className={styles.modal_wrapper}>
      <div className={styles.text_wrapper}>
        <div className={styles.warning_text}>{warning}</div>
        <div className={styles.details_text_wrapper}>
          <div className={styles.balance_text}>
            You have
            {isFetchingBalance ? (
              <Loader />
            ) : (
              <span> {creditBalance} credits</span>
            )}
          </div>
          <div className={styles.price_text}>{price}</div>
        </div>
      </div>
      <div className={styles.buttons_wrapper}>
        <div className={styles.button_wrapper}>
          <IncreaseLimitsButton filled={false} onClick={hideModal} />
        </div>
        <div className={styles.button_wrapper}>
          <FilledButton
            text={"USE CREDITS"}
            backgroundColor={"#FF6722"}
            onClick={onUseCreditsClick}
          />
        </div>
      </div>
    </div>
  );
};

export default LimitExpiredCreditModal;
